define(['ko', '_', 'search/facet', 'search/facetvalue', 'search/category', 'bindings/stopBinding', 'bindings/shiftClick', 'koFastForeach'], function (ko, _, facetViewModel, facetValueViewModel, categoryViewModel) {
    ko.components.register('facet-filter', {
        viewModel: require('components/facet-filter/filter'),
        template: require('components/facet-filter/filter.html')
    });
    ko.components.register('facet-category-filter', {
        viewModel: require('components/facet-filter/filter-category'),
        template: require('components/facet-filter/filter-category.html')
    });
    ko.components.register('filter-category-page', {
        viewModel: require('components/facet-filter/filter-category-page'),
        template: require('components/facet-filter/filter-category-page.html')
    });
    ko.components.register('product-tile', {
        viewModel: require('components/product-tile/product-tile'),
        template: require('components/product-tile/product-tile.html')
    });
    ko.components.register('pagination', {
        viewModel: require('components/pagination/pagination'),
        template: require('components/pagination/pagination.html')
    });

    window.copyTree = function (originalTree, level) {
        if (_.isUndefined(level)) {
            level = 1;
        }
        return originalTree.map(function (category) {
            var vm = new categoryViewModel(category, level);
            if (category.categories.length >= 1) {
                vm.categories = copyTree(category.categories, level + 1);
            }

            return vm;

        });
    };

    return function SearchResultViewModel(pageType, term, products, pages, currentPage, resultCount, facets, favorites, restrictedFacets, favoriteSkus, categories, currentCategory) {
        self = this;

        var allowedPageTypes = ['category', 'search', 'favorites'];
        if (_.includes(allowedPageTypes, pageType)) {
            self.pageType = pageType;
        } else {
            console.debug('UNKNOWN PAGE TYPE: ' + pageType);
            self.pageType = 'search';
        }

        self.term = ko.observable(term);
        self.favoriteTerm = ko.observable(term.replace('*:*', ''));
        self.favoriteTermValue = ko.computed({
            read: function () {
                return self.favoriteTerm().replace('*:*', '');
            },
            write: function (value) {
                self.favoriteTerm(value);
                self.handleSubmit();
            },
            owner: self
        });

        self.isMerging = ko.observable(false);
        self.lastChecked = ko.observable(null);
        self.products = ko.observableArray(products);
        self.selectedProducts = ko.observableArray([]);
        self.currentPage = ko.observable(currentPage);
        self.currentCategory = !_.isUndefined(currentCategory) ? currentCategory : null;
        self.totalResults = ko.observable(resultCount);
        self.categoryTree = ko.observable(categories);
        self.selectedCategory = ko.pureComputed(function () {
            return flattenMyTree(self.categoryTree()).filter(function (c) {
                return c.checked() === true;
            })[0];
        });
        self.checkedCategories = ko.observableArray([]);
        self.pageSize = ko.observable(12);
        self.totalPages = ko.observable(pages);
        self.pageStart = ko.pureComputed(function () {
            return self.pageSize() * (self.currentPage() - 1) + 1;
        });
        self.pageEnd = ko.pureComputed(function () {
            return (self.pageStart() - 1) + self.products().length;
        });
        // public int PageStart => PageSize * (CurrentPage - 1) + 1;
        // public int PageEnd => PageStart -1 + Tiles.Count;
        // array of facet names which the user is not allowed to see or change
        self.restrictedFacets = ko.observableArray(!_.isEmpty(restrictedFacets) ? restrictedFacets : []);
        self.facets = ko.observableArray(facets.map(function (facet) {
            return new facetViewModel(facet);
        }));
        self.favorites = ko.observableArray(favorites);
        // undefined OR an array of skus. Should only be set on the favorites page.
        // will add a Sku filter with this value to all search request if this is NOT undefined
        self.favoriteSkus = favoriteSkus;

        self.loader = ko.observable(0);
        self.requestCounter = 0;

        // todo: cart (outside this viewmodel)

        // self.getStandardIcon = function(identifier) {
        //     return _.find(self.standards(), ['identifier', identifier]).icon;
        // };

        self.isFavorite = function (sku) {
            return _.includes(self.favorites(), sku);
        };

        self.checkedFacets = ko.pureComputed(function () {
            var checked = [];
            self.facets().forEach(function (facet) {
                var selected = _.filter(facet.values(), function (val) {
                    return val.checked();
                });
                selected.forEach(function (facetValue) {
                    checked.push({name: facet.name, value: facetValue.name(), valueLabel: facetValue.label(), label: facet.label});
                });
            });
            return checked;
        });

        self.checkedFacetsGrouped = ko.pureComputed(function () {
            var groupedAndSorted = _.groupBy(_.sortBy(self.checkedFacets(), (facet) => facet.label), 'label');
            return _.map(_.toPairs(groupedAndSorted), (item) => {
                var restricted = false;
                if (!_.isEmpty(item) && !_.isEmpty(item[1])) {
                    restricted = _.includes(self.restrictedFacets(), item[1][0].name);
                }
                return {key: item[0], values: item[1], restricted: restricted};
            });
        });
        /**
         * Returns true if selected facets/filters/categories should be visible
         */
        self.showFilterPills = ko.pureComputed(function () {
            if (self.pageType === 'category') {
                // category page has different logic to display selected categories. Hide the pills div if no regular facet is selected to prevent only showing a "clear all filters" button without any pills
                return _.filter(self.checkedFacetsGrouped(), {'restricted': false}).length > 0;
            }
            // all other pages can show the category pill(s)
            return _.filter(self.checkedFacetsGrouped(), {'restricted': false}).length > 0 || self.checkedCategories().length > 0;
        });

        /**
         * Remove all selected (facet/category)filters except restricted facets
         */
        self.clearAllFilters = function () {
            _.forEach(self.facets(), function (facet) {
                // do not clear restricted facets to prevent UI quirks
                if (!_.includes(self.restrictedFacets(), facet.name)) {
                    _.forEach(facet.values(), function (value) {
                        value.checked(false);
                    });
                }
            });
            if (self.pageType !== 'category') {
                // category should not be unchecked on category pages
                flattenMyTree(self.categoryTree()).forEach(function (c) {
                    c.checked(false);
                });
            }
            $('#search_filters input:checked').prop('checked', false);
            self.handleSubmit();
        };
        self.clearFilter = function (data) {
            var facet = _.find(self.facets(), ['name', data.name]);
            if (!_.isUndefined(facet)) {
                var val = _.find(facet.values(), function (val) {
                    return val.name() === data.value;
                });
                if (!_.isUndefined(val)) {
                    val.checked(false);
                }
            }
            self.handleSubmit();
        };
        self.selectCategory = function (data) {
            flattenMyTree(self.categoryTree()).forEach(function (c) {
                // only allow a single category to be selected (for now)
                c.checked(c.id === data.id);
            });
            self.handleSubmit();
        };
        self.clearCategories = function (data) {
            self.checkedCategories(_.filter(self.checkedCategories(), function (cat) {
                return cat !== data.id;
            }));
            flattenMyTree(self.categoryTree()).forEach(function (c) {
                // only allow a single category to be selected (for now)
                if (c.id === data.id) {
                    c.checked(false);
                }
            });
            self.handleSubmit();
        };

        self.gotoPreviousPage = function () {
            if (self.currentPage() === 1) {
                return false;
            }
            self.gotoPage(self.currentPage() - 1);
        };
        self.gotoNextPage = function () {
            if (self.totalPages() === self.currentPage()) {
                return false;
            }
            self.gotoPage(self.currentPage() + 1);
        };
        self.gotoPage = function (page) {
            document.getElementById('products-wrapper').scrollIntoView({
                behavior: 'smooth'
            });
            self.handleSubmit(page);
        };
        self.gotoFirstPage = function () {
            self.gotoPage(1);
        };
        self.gotoLastPage = function () {
            self.gotoPage(self.totalPages());
        };

        self.appliedFilters = ko.observableArray([]);
        self.handleSubmit = function (page) {
            var previousCheckedCat = self.checkedCategories();
            self.checkedCategories([]);

            var newSelectedCats = flattenMyTree(self.categoryTree()).filter(function (c) {
                return c.checked() === true;
            }).map(function (c) {
                return c.id;
            });
            if (newSelectedCats.length > 1) {
                _.forEach(newSelectedCats, function (catId) {
                    if (!_.includes(previousCheckedCat, catId)) {
                        self.checkedCategories.push(catId);
                    }
                });
            } else {
                newSelectedCats.forEach(function (id) {
                    self.checkedCategories.push(id);
                });
            }

            self.appliedFilters([]);
            if (!_.isUndefined(page) && _.parseInt(page) > 0) {
                self.currentPage(page);
            } else {
                // when a filter is applied no page param is provided, reset to 1
                self.currentPage(1);
            }
            self.facets().map(function (facet, i) {
                var obj = {};
                var checkedValues = facet.getCheckedValues();
                if (checkedValues.length > 0) {
                    obj.name = facet.name;
                    obj.values = [];
                    _.forEach(checkedValues, function (checkedValue) {
                        obj.values.push(checkedValue.name);
                    });
                    if (facet.name !== 'category') {
                        self.appliedFilters.push(obj);
                    }
                }
            });

            self.searchProducts();
        };

        self.checkedCategoryModels = ko.computed(function () {
            var out = [];
            flattenMyTree(self.categoryTree()).filter(function (c) {
                return c.checked() === true;
            }).forEach(function (category) {
                out.push(category);
            });
            return out;
        });
        self.selectedCategoryTree = ko.pureComputed(function () {
            var out = [];
            if (_.isUndefined(self.selectedCategory())) {
                return out;
            }
            flattenMyTree(self.categoryTree()).forEach(function (c) {
                if (_.includes(self.selectedCategory().pathIds, c.id)) {
                    out.push(c);
                }
            });
            return _.sortBy(out, function (c) {
                return c.pathIds.length;
            });
        });

        function flattenMyTree(tree) {
            function recurse(nodes, path, pathIds, parentId, parentSlug) {
                return _.map(nodes, function (node) {
                    var newPath = _.union(path, [node.name]);
                    var newPathIds = _.union(pathIds, [node.id]);
                    var newSlug = _.union(parentSlug, [node.slug]);
                    return [
                        _.assign(
                            {
                                pathname: newPath.join(' > '),
                                url: newSlug.join('/'),
                                level: path.length,
                                pathIds: newPathIds,
                                parentId: parentId
                            },
                            _.omit(node, 'categories')
                        ),
                        recurse(node.categories, newPath, newPathIds, node.id, newSlug),
                    ];
                });
            }

            return _.flattenDeep(recurse(tree, []));
        }

        // initalize checked categories on page load
        _.map(self.checkedFacets(), function (facet) {
            if (facet.name === 'category') {
                var checkedCategoryId = parseInt(facet.value, 10);
                self.checkedCategories.push(checkedCategoryId);
                flattenMyTree(self.categoryTree()).filter(function (c) {
                    return c.id === checkedCategoryId;
                }).forEach(function (category) {
                    category.checked(true);
                });
            }
        });

        self.abortController = new AbortController();
        self.abortSignal = self.abortController.signal;
        self.searchFavoriteProducts = function () {
            self.term("");
            self.handleSubmit();
        };
        self.resetSearchFavoriteProducts = function () {
            self.favoriteTermValue("");
            self.handleSubmit();
        };
        self.searchProducts = function () {

            var requestId = self.requestCounter;
            self.requestCounter++;
            self.loader(self.loader() + 1);

            const data = new URLSearchParams();
            var filterIndex = 0;
            _.forEach(self.appliedFilters(), function (filter, index) {
                data.append(`filters[${index}].Name`, filter.name);
                _.forEach(filter.values, function (filterValue) {
                    data.append(`filters[${index}].Values`, filterValue());
                });
                filterIndex = index + 1;
            });
            if (self.checkedCategories().length > 0) {
                data.append(`categories[0]`, _.last(self.checkedCategories()));
            }
            if (self.pageType === 'category' && self.checkedCategories().length === 0) {
                data.append(`categories[0]`, self.currentCategory.id);
            }

            if (!_.isUndefined(self.favoriteSkus)) {
                data.append('favorites', 'true');
                data.append('searchterm', self.favoriteTermValue());
            } else {
                data.append('searchterm', self.term());
            }

            data.append('page', self.currentPage());

            // console.debug(data.toString());

            self.abortController.abort(); // abort previous requests
            self.abortController = new AbortController();

            fetch('/internal-api/search?', {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: data,
                signal: self.abortController.signal,
            })
            .then(response => response.json())
            .then(response => {
                var shouldProcess = (requestId + 1) === self.requestCounter;
                if (!shouldProcess) {
                    // console.log(`[SKIP] skip request ${requestId}`);
                    return false;
                }
                // console.log(`[OK] process request ${requestId}`);
                self.products(response.tiles);

                var catTree = window.copyTree(response.categoryFacet, 1);
                self.categoryTree(catTree);

                var responseFacetVms = response.facets.map(function (facet) {
                    return new facetViewModel(facet);
                });
                let responseFacets = _.keyBy(responseFacetVms, (facet) => facet.name);
                var vmFacets = _.keyBy(self.facets(), (facet) => facet.name);

                var vmFacetKeys = _.keys(vmFacets);
                var responseKeys = _.keys(responseFacets);

                var vmMissingKeys = _.difference(responseKeys, vmFacetKeys);
                var responseMissingKeys = _.difference(vmFacetKeys, responseKeys);
                //  voeg alle filters toe die niet bestaan maar wel voorkomen in de response
                _.forEach(vmMissingKeys, (facetName) => {
                    // console.log('add newly added facet: ' + facetName, responseFacets[facetName]);
                    self.facets.push(responseFacets[facetName]);
                });
                // zet alle filters op 0 die niet voorkomen in de response
                _.forEach(responseMissingKeys, (facetName) => {
                    // console.log('set all values count to 0 for facet: ' + facetName, vmFacets[facetName], vmFacets[facetName].values().length);
                    _.forEach(vmFacets[facetName].values(), (val) => {
                        val.count(0);
                    });
                });
                // zet alle filters hun count die wel voorkomen in de response
                _.forEach(_.intersection(vmFacetKeys, responseKeys), (facetName) => {
                    let matchingResponseFacet = responseFacets[facetName];
                    let matchingVmFacet = vmFacets[facetName];
                    _.forEach(matchingVmFacet.values(), (val) => {
                        // attempt to find the matching facet value in the response
                        var matchingValue = _.find(matchingResponseFacet.values(), (rVal) => rVal.name() === val.name());
                        if (!_.isUndefined(matchingValue)) {
                            // response has a new count for the facet value
                            val.count(matchingValue.count());
                        } else {

                            // response doesn't have this facet value, make it 0 in the interface
                            val.count(0);
                        }
                    });
                });
                // voeg alle filter opties toe die niet bestaan
                _.forEach(responseFacetVms, (facet) => {
                    _.forEach(facet.values(), (val) => {
                        if (!_.isUndefined(vmFacets[facet.name])) {
                            var valMatch = _.find((vmFacets[facet.name].values()), (vmVal) => vmVal.name() === val.name());
                            if (_.isUndefined(valMatch)) {
                                vmFacets[facet.name].values.push(val);
                            }
                        }
                    });
                });
                _.forEach(self.facets(), function (facet) {
                    if (facet.name !== "stock" && facet.name !== "category") {
                        facet.values.remove(function (facetValue) {
                            return facetValue.count() === 0;
                        });
                    }
                });
                self.facets.remove(function (facet) {
                    if (facet.name === "stock" || facet.name === "category") {
                        return false;
                    }

                    return facet.values().length === 0;
                });

                self.totalPages(response.pages);
                self.currentPage(response.currentPage);
                self.totalResults(response.count);
                // self.pageSize(data.pageSize);
            })
            .catch(function (error) {
                console.error('fetch error:', error);
            })
            .finally(function () {
                self.loader(self.loader() - 1);
                // manually reset location.search to prevent strange issues
                const currentUrl = window.location.toString().replace(window.location.search.toString(), '');
                const url = new URL(currentUrl);
                url.searchParams.set('page', self.currentPage());

                if (!_.isUndefined(self.favoriteSkus)) {
                    url.searchParams.set('favoriteterm', self.favoriteTermValue());
                } else {
                    url.searchParams.set('searchterm', self.term());
                }

                // todo: apply category filters
                _.forEach(self.checkedCategories(), function (categoryId, index) {
                    // console.log('SET URL FOR checked category: ' + categoryId);
                    url.searchParams.set(`categories[${index}]`, categoryId);
                });
                _.forEach(self.appliedFilters(), function (filter, index) {
                    url.searchParams.set(`filters[${index}].Name`, filter.name);
                    _.forEach(filter.values, function (filterValue) {
                        url.searchParams.append(`filters[${index}].Values`, filterValue());
                    });
                });
                // Replace the category in the URL if path starts with /categorie/ or /categories/
                // This fixes: https://github.com/DistilBV/PimShop/issues/132
                var isCategoryPage = url.pathname.toLowerCase().startsWith('/categorie')
                if (isCategoryPage) {
                    if (self.selectedCategory()) {
                        // Update URL with the selected category's URL
                        url.pathname = '/categories/' + self.selectedCategory().url;
                    }
                }
                window.history.replaceState({}, '', url);
            });
        };
    };
});

